/**
 * Analyzer status indicator - shows if the AI neural network is running
 */

import { useEffect, useState } from 'react'
import { Badge, Tooltip, Space, Typography } from 'antd'
import { ThunderboltOutlined } from '@ant-design/icons'
import { apiClient } from '@/services/api'

const { Text } = Typography

interface SystemStatus {
  backend: { status: string }
  analyzer: { status: string; healthy: boolean; error?: string }
  config: { analyzer_concurrency: number; rate_limit_rpm: number; gemini_keys_count: number }
}

function AnalyzerStatus() {
  const [status, setStatus] = useState<'healthy' | 'error' | 'loading'>('loading')
  const [details, setDetails] = useState<string>('')

  const fetchStatus = async () => {
    try {
      const response = await apiClient.get<SystemStatus>('/monitoring/system')
      const data = response.data
      if (data.analyzer?.healthy) {
        setStatus('healthy')
        setDetails(`Нейронка работает | Ключей: ${data.config?.gemini_keys_count || '?'} | RPM: ${data.config?.rate_limit_rpm || '?'}`)
      } else {
        setStatus('error')
        setDetails(data.analyzer?.error || 'Анализатор недоступен')
      }
    } catch {
      setStatus('error')
      setDetails('Не удалось проверить статус')
    }
  }

  useEffect(() => {
    fetchStatus()
    const interval = setInterval(fetchStatus, 30000)
    return () => clearInterval(interval)
  }, [])

  const color = status === 'healthy' ? '#52c41a' : status === 'error' ? '#ff4d4f' : '#faad14'
  const label = status === 'healthy' ? 'AI' : status === 'error' ? 'AI' : '...'

  return (
    <Tooltip title={details || 'Проверка...'}>
      <Space
        size={4}
        style={{
          padding: '4px 10px',
          borderRadius: '6px',
          background: status === 'healthy' ? '#f6ffed' : status === 'error' ? '#fff2f0' : '#fffbe6',
          border: `1px solid ${color}40`,
          cursor: 'default',
        }}
      >
        <Badge status={status === 'healthy' ? 'success' : status === 'error' ? 'error' : 'warning'} />
        <ThunderboltOutlined style={{ color, fontSize: '14px' }} />
        <Text style={{ fontSize: '13px', color, fontWeight: 500 }}>{label}</Text>
      </Space>
    </Tooltip>
  )
}

export default AnalyzerStatus
